<style lang="less">
      @import '../styles/man.less';
</style>
<template>
    <div  class="man_1 ">
        <div class="man_bj">
            <img src="../../static/images/bg.png"/>
        </div>
        <div class="man">
            <div class="man_head">
                <Home_Head></Home_Head>
            </div>
            <div class="man_end">
                <div class="man_end_1">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Home_Head from "./Home_Head/Home_Head.vue";
    import Cookies from "js-cookie";
    import bus from "../app/event";
    export default {
        components: {
            Home_Head,
        },
        data() {
        return {
        };
        },
        directives:{
        },
        methods: {
        },
        mounted() {
        },
    };
</script>




// WEBPACK FOOTER //
// man.vue?0d41f63e